var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
    "dismiss": `Negeren`
};


export {$9d025808aeec81a7$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
